module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.6587/img/provider-signup/community-creators-blobs.png"